import { mapState } from 'vuex'

export default {
  props: {
    boardId: { type: String, required: true }
  },
  data () {
    return {
      useCheckbox: false,
      selected: false,
      board: {
        count: 0,
        rows: []
      }
    }
  },
  created () {
    this.useCheckbox = this.user.level >= this.$utils.getLevel('master1')
    this.search()
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    async search () {
      this.board = await this.$search(`/api/boards/${this.boardId}`)

      const { page = 0, limit = 0 } = this.$utils.params('page')
      this.board.rows = this.board.rows.map((row, index) => {
        if (row.noticeFlag !== 'Y') {
          row.num = this.board.count - index - page * limit
        } else {
          row.num = '공지'
        }
        return row
      })
    },
    async selectAll () {
      this.selected = !this.selected
      this.board.rows = await this.$selectAll(this.board.rows, this.selected)
    },
    async removeSelected () {
      // const ret = await this.$removeSelected(row => `/api/boards/${this.boardId}/seqs/${row.seq}`, this.board.rows)
      // ret && (await this.search())
      await this.$removeSelected(row => `/api/boards/${this.boardId}/seqs/${row.seq}`, this.board.rows)
      await this.search()
    },
    async toggleUseFlag (row) {
      try {
        const { seq, useFlag } = row
        const body = {
          useFlag: useFlag === 'Y' ? 'N' : 'Y'
        }
        row.useFlag = body.useFlag
        await this.$http.patch(`/api/boards/${this.boardId}/${seq}`, body)
        this.search()
      } catch (ex) {
        // if (ex.response) {
        //   const { field, msg } = ex.response.data
        //   this.error = { field, msg }
        // }
        console.error(ex, ex.response)
      }
    },
    goView (seq) {
      this.$router.push({
        name: !this.isAdminMode ? 'boardView' : 'adminBoardEdit',
        params: { boardId: this.boardId, seq },
        query: this.$route.query
      })
    }
  }
}
